import { CspError, ObjectType } from '@csp/csp-common-model';
import { QuestionnaireContentModel } from '@csp/csp-pod-patient-content-definitions';
import { isArray, isPlainObject, mapValues } from 'lodash';
import { QuestionnaireContent } from '../model/QuestionnaireContent';

/**
 * Converts all empty string fields in a Contentstack Entry to undefined.
 * For example, a non-mandatory text field with an empty string will be set to undefined.
 * @param entry
 */
export const emptyStringToUndefined = (entry: QuestionnaireContent): QuestionnaireContent =>
  emptyStringToUndefinedInternal(entry) as QuestionnaireContent;

const emptyStringToUndefinedInternal = (value: unknown): unknown => {
  if (isPlainObject(value)) {
    return mapValues(value as ObjectType, emptyStringToUndefined);
  }
  if (isArray(value)) {
    return value.map(emptyStringToUndefined);
  }
  if (value === '') {
    return undefined;
  }
  return value;
};

/**
 *
 * @param questionnaire Raw Questionnaire From Content Stack
 * @returns Formated to usable state - QuestionnaireContent
 */
export const rawToQuestionnaireContent = (questionnaire: QuestionnaireContentModel): QuestionnaireContent => {
  const [questionnaire_card] = questionnaire.questionnaire_card ?? [];
  const [thank_you] = questionnaire.thank_you ?? [];
  const [questionnaire_assessment] = questionnaire.questionnaire_assessment ?? [];

  if (!questionnaire_card || !thank_you || !questionnaire_assessment) {
    throw CspError.badState(
      `Missing questionnaire_card, thank_you or questionnaire_assessment in questionnaire with code ${questionnaire.questionnaire_code} and uid ${questionnaire.uid}`,
    );
  }

  if (!questionnaire_assessment.included_questions || !questionnaire.questionnaire_specific_questions) {
    throw CspError.badState(
      `questionnaire_assessment.included_questions or questionnaire_specific_questions are undefined for question with code ${questionnaire.questionnaire_code}`,
    );
  }

  return emptyStringToUndefined({
    ...questionnaire,
    questionnaire_card,
    thank_you,
    questionnaire_assessment: {
      ...questionnaire_assessment,
      included_questions: questionnaire_assessment.included_questions,
    },
    questionnaire_specific_questions: questionnaire.questionnaire_specific_questions,
  });
};
